import type { FC } from "react"
import { useCallback, useState } from "react"

import type { FlattenSimpleInterpolation } from "styled-components"
import { css } from "styled-components"

import { Wrapper } from "../utils/Wrapper"

export type TabProps = {
  tabs: React.ReactNode[]
  names: string[]
  css?: FlattenSimpleInterpolation
  onTabChange?: (index: number) => void
}

const defaultTabCSS = css`
  display: inline-block;
  width: 100%;

  border: 3px solid #ffffff;
  border-radius: 10px;

  & > ul {
    list-style: none;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    background-color: #ffffff;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    margin-bottom: 2em;
  }
  & > ul > li {
    flex-grow: 1;
    text-align: center;
    padding: 0.5em 1em;
    margin: 0.5em 1em;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    text-transform: uppercase;
    border-radius: 6px;
    cursor: pointer;

    color: #0070f4;

    transition: background-color 0.2s ease-in-out;
    transition: color 0.2s ease-in-out;
  }
  & > ul > li[data-active="true"] {
    background-color: #0070f4;
    color: #ffffff;
  }
`
export const Tab: FC<TabProps> = ({
  tabs,
  names,
  css = defaultTabCSS,
  onTabChange,
}: TabProps) => {
  const [activeTab, setActiveTab] = useState(0)

  const onClickGenerator = (index: number) => () => {
    setActiveTab(index)
    if (onTabChange) onTabChange(index)
  }

  return (
    <Wrapper css={css}>
      <ul data-testid="tabs">
        {names.map((name, index) => (
          <li
            key={`${name}-${index}`}
            data-active={activeTab == index}
            onClick={onClickGenerator(index)}
            data-testid={`tab-${index}`}
          >
            {name}
          </li>
        ))}
      </ul>
      <div data-testid="tab-content">{tabs[activeTab]}</div>
    </Wrapper>
  )
}
